<template>
  <a-config-provider :locale="zh_CN">
    <router-view :key="$route.fullPath"></router-view>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
export default {
  name: "App",
  components: {},
  setup() {
    const zh_CN = zhCN;
    return {
      zh_CN,
    };
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-menu-item {
  display: flex;
  align-items: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
